<template>
  <div>
    <vue-element-loading :active="loading_addresses" />
    <b-form-group v-if="!loading_addresses" class="w-100">
      <div
        v-for="(address, index) in getAddressByCurrentPatient"
        :key="index"
        class="my-2 p-2 address-option w-100"
        v-bind:class="{
          'address-selected': selected_address_uuid === address.uuid,
        }"
      >
        <b-row>
          <b-col cols="10" md="10">
            <b-form-radio
              v-model="selected_address_uuid"
              :value="address.uuid"
              name="delivery-addresses"
              @input="
                handleAddressInput($event);
                onAddressClick($event);
              "
              :disabled="
                filter_address_by_current_country &&
                  address.country != deviceCountry
              "
            >
              <span class="name">{{ address.name }}</span>
              ,
              {{ address.address }}, {{ address.town }}, {{ address.colony }},
              {{ address.postal_code }},
              {{ address.country }}
            </b-form-radio>
          </b-col>
          <b-col cols="2" md="2" class="text-right">
            <b-button
              v-if="
                aUuidEdit != address.uuid &&
                  !(
                    filter_address_by_current_country &&
                    address.country != deviceCountry
                  )
              "
              size="xs"
              variant="secundary-b"
              @click="
                showAddressForm = true;
                aUuidEdit = address.uuid;
                selectAddress(address.uuid);
              "
            >
              {{ $t("addresses_lite.edit") }}
            </b-button>
            <b-button
              v-if="showAddressForm && aUuidEdit == address.uuid"
              size="xs"
              variant="secundary-b"
              @click="
                showAddressForm = false;
                aUuidEdit = undefined;
              "
            >
              {{ $t("addresses_lite.close") }}
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-form-group>
    <button
      v-if="!(showAddressForm && aUuidEdit == undefined)"
      class="btn btn-secondary"
      v-on:click="
        aUuidEdit = undefined;
        showAddressForm = true;
      "
    >
      {{ $t("addresses_lite.add_address") }}
    </button>
    <button
      v-if="showAddressForm && aUuidEdit == undefined"
      class="btn btn-secondary"
      v-on:click="
        aUuidEdit = undefined;
        showAddressForm = false;
      "
    >
      {{ $t("addresses_lite.cancel") }}
    </button>
    <b-card class="border mt-3" v-if="showAddressForm">
      <VAddressForm
        :a_uuid="aUuidEdit"
        v-on:address-new-updated="handleNewUpdatedAddress"
      />
    </b-card>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import { mapGetters } from "vuex";
import { mapState } from "vuex";
import VAddressForm from "@/components/AddressForm";

export default {
  components: {
    VAddressForm,
  },
  props: {
    value: {
      type: String,
      default: undefined,
    },
    filter_address_by_current_country: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      addresses: [],
      loading_addresses: true,
      internal_address_uuid: undefined,
      showAddressForm: false,
      aUuidEdit: undefined,
    };
  },
  watch: {
    getUuidPatientSelected: function() {
      this.loadAddresses();
    },
  },
  computed: {
    ...mapState({
      loading: state => state.appstatus.loading,
    }),
    ...mapGetters("naturalperson", [
      "getUuidPatientSelected",
      "getAddressByCurrentPatient",
    ]),
    ...mapGetters("auth", ["deviceCountry"]),
    selected_address_uuid: {
      get() {
        // Se usan los dos valores para que el componente sea funcional
        // aunque no tenga nada en v-model
        return this.internal_address_uuid || this.value;
      },
      set(newValue) {
        this.internal_address_uuid = newValue;
      },
    },
  },
  created() {
    this.loadAddresses();
  },
  methods: {
    selectAddress(addressUuid) {
      this.selected_address_uuid = addressUuid;
      this.$emit("address-select", addressUuid);
      this.$emit("input", addressUuid);
    },
    handleNewUpdatedAddress(address) {
      this.loadAddresses(address.uuid);
      this.showAddressForm = false;
      this.aUuidEdit = undefined;
    },
    handleAddressInput: debounce(function(value) {
      this.selectAddress(value);
    }, 1000),
    onAddressClick: function() {
      this.$emit("address-click");
    },
    resetSelectedAddress() {
      this.selectAddress(undefined);
    },
    loadAddresses: function(addressUuid = undefined) {
      this.resetSelectedAddress();
      this.loading_addresses = true;
      if (this.getUuidPatientSelected) {
        this.$store
          .dispatch("naturalperson/REQUEST_ADDRESSES", {
            pt_uuid: this.getUuidPatientSelected,
          })
          .then(
            response => {
              if (!this.selected_address_uuid) {
                var main_address = response.data.results.filter(
                  a => a.is_main
                )[0];
                if (main_address && addressUuid == undefined) {
                  this.selectAddress(main_address.uuid);
                }
              }
              if (addressUuid != undefined) {
                this.selectAddress(addressUuid);
              }
              this.loading_addresses = false;
            },
            err => {
              this.loading_addresses = false;
              this.$sentry({ capture: err });
              this.mnotify_error({
                text: this.$t("addresses_lite.error.address_retrieve_error"),
              });
            }
          );
      } else {
        // no hay paciente seleccionado, probablemente no lo ha rellenado
        // aún (main patient). No estamos cargando nada en este caso.
        this.loading_addresses = false;
      }
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        addresses_lite: {
          edit: "Edit",
          close: "Close",
          cancel: "Cancel add a new address",
          add_address: "Add a new address",
          error: {
            address_retrieve_error: "Cannot retrieve address",
            address_delete_error: "Cannot delete address",
          },
        },
      },
    },
  },
};
</script>

<style scoped lang="scss">
.name {
  font-weight: bold;
}

.address-option {
  border: 1px solid transparent;
}

.address-selected {
  background-color: $corp-color2-transparent;
  border: 1px solid $corp-color2;
  border-radius: 5px;
}
</style>
